import { Search } from 'lucide-react';

import { cn } from '@/utils/cn';

type SectionSearchFieldProps = {
  value: string;
  placeholder: string;
  ariaLabel: string;
  onChange: (value: string) => void;
  filtersClassName?: string;
  fieldClassName?: string;
};

export function SectionSearchField({
  value,
  placeholder,
  ariaLabel,
  onChange,
  filtersClassName,
  fieldClassName,
}: SectionSearchFieldProps) {
  return (
    <div className={cn('dashboard-overview-card__filters', filtersClassName)}>
      <label className={cn('dashboard-search-field', fieldClassName)}>
        <Search size={16} aria-hidden="true" />
        <input
          type="search"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          aria-label={ariaLabel}
        />
      </label>
    </div>
  );
}